@use "sass:list";
@use "../../../globals/settings";
@use "../../../globals/bcp";

// icon.generated.scss file below is generated by: npm run icons.theme.xxx but only if there is related zip file
// If not use the file copied from Frok repository where it was generated by: node icon.js Bosch-Icon-2-5.zip 2.5 icon
// there is a backup file _icon-2-5.generated.scss just in case
@use "../../basics/styles/icon/icon.generated.scss" as icons-generated;

// since there is no newer wersion of ui-icons the file below is just a copy from Frok repository where it was
// generated by: node icon.js Bosch-Ui-Icon-1-2.zip 1.2 ui-icon
// there is a backup file _ui-icon-1-2.generated.scss just in case
@use "../../basics/styles/icon/ui-icon.generated.scss" as ui-icons-generated;

:host {
  @include bcp.generate-icon-classes(ui-icons-generated.$ui-icons);
  @include bcp.generate-icon-classes(icons-generated.$icons);

  // ------------------- FIX CUSTOM TAGS ------------------------------------------------------------------------------
  // was: inline-block, but it generated extra space at the bottom
  display: inline-flex;
  text-decoration: none;
}

/**
  no generic font family (see original BoschIcon font styles);
  use !important to prevent issues with browser extensions that change fonts
*/
[class^="boschicon-bosch-ic"],
[class*=" boschicon-bosch-ic"] {
  @include bcp.icon-core-styles;
  font-family: "Icon", sans-serif !important;
}

[class^="ui-ic"],
[class*=" ui-ic"] {
  @include bcp.icon-core-styles;
  font-family: "UI-Icon", sans-serif !important;
}

// ------------------- FROK -----------------------------------------------------------------------------------------
.a-icon {
  @include bcp.decl(icon, color, inherit, true);

  // sizes
  @each $icon in bcp.$icon-sizes {
    $icon-name: list.nth($icon, 1);
    $icon-size: list.nth($icon, 2);
    &--#{$icon-name} {
      font-size: bcp.cssVar(icon, size, $icon-size * 1px);
    }
  }

  // added here due to shadow dom, to fix underlined icons inside links
  // assuming no one ever will want to have underline for icon
  &,
  &::before,
  &::after {
    display: inline-block;
    text-decoration: none;
  }
}
